import * as React from 'react';

import CustomSkill56 from './CustomSkill56';

export const customSkill56 = () => <CustomSkill56 />;

export default {
    title: 'Illustration/CustomSkill56',
    component: CustomSkill56,
    parameters: {
        notes: "`import CustomSkill56 from 'box-ui-elements/es/illustration/CustomSkill56';`",
    },
};
